export enum ProjectStatus {
  Archived,
  Active,
  Locked
}
